import PrimaryColorButton from './Primary';
import SecondaryColorButton from './Secondary';

type Translations = {
  trending?: string;
};

type Props = {
  active?: boolean;
  backgroundColor: string;
  className?: string;
  colorType?: 'default' | 'transparant';
  id?: string;
  isFavorite?: boolean;
  loading?: boolean;
  name?: string;
  onClick?: () => void;
  onClickAction?: 'navigate' | 'click';
  onFavorite?: () => void;
  slug?: string;
  trackInfo?: Record<string, string | number>;
  translations?: Translations;
  trending?: boolean;
  variant?: 'primary' | 'secondary';
};

export type ColorButtonProps = Omit<Props, 'variant'>;

const ColorButton = ({ variant = 'primary', ...props }: Props) => {
  if (variant === 'secondary') {
    return <SecondaryColorButton {...props} />;
  }
  return <PrimaryColorButton {...props} />;
};

export default ColorButton;
